export default __webpack_public_path__ + "static/media/samsara-logo.cc18e43a.png";